import { homepageSkyscraperUnits } from "./homepageSkyscraper";
import { DesktopHomepageScrollUnits } from "./homepageScrollDesktop";
import { MobileHomepageScrollUnits } from "./homepageScrollMobile";

import { ContentPageSkyscraperUnits } from "./contentPageSkyscraper";
import { DesktopContentPageScrollUnits } from "./contentPageScrollDesktop";
import { MobileContentPageScrollUnits } from "./contentPageScrollMobile";

import { ProfilePageSkyscraperUnits } from "./profilePageSkyscraper";

import { FooterUnits } from "./footer";

import { SpecialUnits } from "./special";

export type AdUnitsKeys = keyof typeof units;

export const units = {
  ...homepageSkyscraperUnits,
  ...DesktopHomepageScrollUnits,
  ...MobileHomepageScrollUnits,

  ...ContentPageSkyscraperUnits,
  ...DesktopContentPageScrollUnits,
  ...MobileContentPageScrollUnits,

  ...ProfilePageSkyscraperUnits,

  ...FooterUnits,

  ...SpecialUnits,
};
